import React from 'react';
import { Link } from 'react-router-dom';
import { logo } from '../data/content';

export default function Footer() {
  const year = new Date().getFullYear();

  const groups = [
    { title: 'Services', links: [
      { label: 'All Services', to: '/services' },
      { label: 'Sales Diagnostic & Build', to: '/services/sales-diagnostic' },
      { label: 'Sales Framework Design', to: '/services/sales-framework-design' },
      { label: 'Team & Hiring Plan', to: '/services/sales-team-hiring' },
      { label: 'Training & Ramp', to: '/services/sales-training-ramp' },
      { label: 'Strategic Advisory', to: '/services/strategic-sales-advisory' },
    ]},
    { title: 'Explore', links: [
      { label: 'Founder-Led Sales', to: '/founder-led-sales' },
      { label: 'About Hannah', to: '/about' },
      { label: 'Testimonials', to: '/testimonials' },
      { label: 'Insights', to: '/insights' },
      { label: 'Contact', to: '/contact' },
    ]},
  ];

  return (
    <footer className="relative">
      <div className="bg-[#1F1D1B] text-[#c9c0b3] pt-20 pb-10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-[#3a3733]">
            <div className="lg:col-span-4">
              <img src={logo} alt="Founder Growth Collective logo" className="w-40 h-auto" />
              <p className="mt-6 font-serif italic text-2xl text-[#EBE4DE] font-light leading-snug max-w-md">
                Sales function design for founder-led startups.
              </p>
              <p className="mt-4 text-sm leading-relaxed max-w-md font-light">
                Strategy › Structure › Scale — Founder Growth Collective partners with a select group of funded founders to build the team, process and structure needed to scale beyond founder-led sales.
              </p>
            </div>

            {groups.map(g => (
              <div key={g.title} className="lg:col-span-3">
                <p className="text-[11px] tracking-[0.24em] uppercase text-[#7a7369] mb-5">{g.title}</p>
                <ul className="space-y-3 text-sm">
                  {g.links.map(l => (
                    <li key={l.to}><Link to={l.to} className="hover:text-[#D8AE94] transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="lg:col-span-2">
              <p className="text-[11px] tracking-[0.24em] uppercase text-[#7a7369] mb-5">Contact</p>
              <ul className="space-y-3 text-sm">
                <li><a href="mailto:hannah@foundergrowthcollective.co.uk" className="hover:text-[#D8AE94] transition-colors break-all">hannah@foundergrowthcollective.co.uk</a></li>
                <li><a href="https://www.linkedin.com" rel="noopener" className="hover:text-[#D8AE94] transition-colors">LinkedIn</a></li>
                <li>Sheffield, UK</li>
                <li>Europe Time Zone</li>
              </ul>
            </div>
          </div>

          <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#7a7369]">
            <p>© {year} Founder Growth Collective. All rights reserved.</p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <Link to="/privacy-policy" className="hover:text-[#D8AE94] transition-colors">Privacy Policy</Link>
              <p className="tracking-[0.2em] uppercase">Startup Sales Consultant · Sales Function Design · UK</p>
            </div>
          </div>
        </div>
      </div>

      {/* Brand mark band — cream strip at the very bottom */}
      <div className="bg-[#EBE4DE] py-8 lg:py-10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex justify-center">
          <img
            src={logo}
            alt="Founder Growth Collective"
            className="w-full max-w-[520px] h-auto"
            loading="lazy"
          />
        </div>
      </div>
    </footer>
  );
}
